import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import {
  getApiV1WeddingsByWeddingIdAuthMeOptions,
  getApiV1WeddingsByWeddingIdTablesMasterAllOptions,
} from '@wedding-tech/api-client/tanstack'

import { FullPageSpinnerPortal } from '@/components/common/Spinner/FullPagePortal'
import { TableMapView } from '@/components/pages/Map/TableMapView'

export const Route = createFileRoute('/e/$eventId/_dashboard/map')({
  component: MapPage,
})

function MapPage() {
  const { eventId } = Route.useParams()
  const { data: userMe, isLoading: isMeLoading } = useQuery({
    ...getApiV1WeddingsByWeddingIdAuthMeOptions({
      path: { weddingId: eventId },
    }),
    staleTime: 60_000,
  })
  const { data: tables, isLoading: isTablesLoading } = useQuery({
    ...getApiV1WeddingsByWeddingIdTablesMasterAllOptions({
      path: { weddingId: eventId },
    }),
    staleTime: 60_000,
  })

  if (isMeLoading || isTablesLoading) {
    return <FullPageSpinnerPortal />
  }

  const highlightedTableNumber = userMe?.status?.hasCheckedIn
    ? userMe?.checkInDetail?.tableAssignment?.tableNumber ||
      (userMe?.checkInDetail as any)?.table ||
      null
    : null

  return (
    <div className="h-full">
      <TableMapView
        tables={tables || []}
        highlightedTableNumber={highlightedTableNumber}
        isLoading={isTablesLoading}
      />
    </div>
  )
}
